var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.88,
    height: 27,
    viewBox: "0 0 16.88 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.88,11V13.5a8.43,8.43,0,0,1-7.6,8.38v3.43h3.38a.85.85,0,0,1,0,1.69H4.22a.85.85,0,0,1,0-1.69H7.59V21.87A8.63,8.63,0,0,1,0,13.2V11a.85.85,0,1,1,1.69,0v2.29a6.92,6.92,0,0,0,6.28,7,6.77,6.77,0,0,0,7.22-6.74V11a.85.85,0,1,1,1.69,0ZM3.38,13.5V5.06a5.06,5.06,0,0,1,10.12,0V13.5a5.06,5.06,0,0,1-10.12,0Zm1.68-.15a3.48,3.48,0,0,0,3,3.51,3.38,3.38,0,0,0,3.71-3.36H9.28a.85.85,0,0,1,0-1.69h2.53V10.12H9.28a.84.84,0,0,1,0-1.68h2.53V6.75H9.28a.85.85,0,0,1,0-1.69h2.53A3.38,3.38,0,0,0,8.09,1.7a3.49,3.49,0,0,0-3,3.52Z",
    fill: "#5b1954"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.7e02e979.svg";
export { ForwardRef as ReactComponent };